import Vue from "vue";
import Vuex from "vuex";


Vue.use(Vuex);
Vue.config.devtools = true;

const store = new Vuex.Store({
  state: {
    menuId: null, //当前页面menuId
    showRecommend: true // 是否显示推荐问题卡片
  },
  mutations: {
    setMenuId(state, id) {
      state.menuId = id;
    },
    setShowRecommend(state, bool) {
      state.showRecommend = bool;
    }
  }
});
export default store;
